<template>
  <div class="burger" ref="burgerRef">
    <p
        class="burger__button"
        @click="setBurgerVisible(!isBurgerVisible)"
    >
      {{ t('header.actions.profile') }}
    </p>
    <div class="burger__menu" :class="[{active: isBurgerVisible}]">
      <div class="burger__menu-wrapper">
        <router-link @click="setBurgerVisible(false)" :to="translations.i18nRoute({ name: 'profile-dashboard' })">{{ t('header.burger.dashboard') }}</router-link>
        <router-link @click="setBurgerVisible(false)" :to="translations.i18nRoute({ name: 'profile-orders' })">{{ t('header.burger.orders') }}</router-link>
        <router-link @click="setBurgerVisible(false)" :to="translations.i18nRoute({ name: 'profile-details' })">{{ t('header.burger.accountDetails') }}</router-link>
        <router-link @click="setBurgerVisible(false)" :to="translations.i18nRoute({ name: 'profile-wishlist' })">{{ t('header.burger.wishlist') }}</router-link>
        <router-link @click="setBurgerVisible(false)" :to="translations.i18nRoute({ name: 'profile-cart' })">{{ t('header.burger.cart') }}</router-link>
        <p @click="logout">{{ t('header.burger.logOut') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {ref} from "vue";
import { onClickOutside } from '@vueuse/core'
import translations from "@/core/helpers/translations.js";
import {useAuthStore} from "@/stores/auth.js";
import {useRouter} from "vue-router";

const {t} = useI18n()
const router = useRouter()
const authStore = useAuthStore()

const isBurgerVisible = ref(false)
const setBurgerVisible = (state) => {
  isBurgerVisible.value = state
}

const burgerRef = ref(null)
onClickOutside(burgerRef, () => isBurgerVisible.value = false)

const logout = async () => {
  authStore.setUser({
    user: null,
    accessToken: null
  })

  localStorage.removeItem('ngs-refresh')
  localStorage.removeItem('ngs-remember')
  localStorage.removeItem('ngs-login')

  await router.push({
    name: 'home',
    params: {
      locale: localStorage.getItem('ngs-user-locale') || 'en-gb'
    }
  })
}
</script>

<style lang="scss" scoped>
.burger {
  position: relative;
  z-index: 3;
  flex-shrink: 0;

  &__button {
    flex-shrink: 0;
    cursor: pointer;
    transition: 0.2s;
    color: #8C8C8C;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;

    @include hover {
      color: #494949;
    }
  }

  &__menu {
    position: absolute;
    z-index: 3;
    top: 200%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 12px;
    background-color: $white;
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.2s ease;
    overflow: hidden;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

    &.active {
      grid-template-rows: 1fr;
    }

    & > * {
      min-height: 0;
    }

    &-wrapper {
      display: flex;
      flex-direction: column;

      & a, p {
        cursor: pointer;
        transition: 0.2s;
        padding: 7px 15px;
        white-space: nowrap;

        color: #777;
        font-size: 16px;
        font-weight: 400;
        line-height: 19.2px;

        @include hover {
          color: #FF8F90;
        }

        &:first-child {
          margin-top: 7px;
        }
        &:last-child {
          margin-bottom: 7px;
        }
      }
    }
  }
}
</style>